import { fetchBankHolidayRegions } from 'syft-acp-core/api/resources/bankHolidayRegions'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('BANK_HOLIDAY_REGIONS_FETCH', fetchBankHolidayRegions)
}
